const CONSENT_REQUESTER_IDENTIFIER_TYPE = "REGNO";
const CONSENT_REQUESTER_IDENTIFIER_SYSTEM = "https://www.mciindia.org";

export function buildConsentRequesterFromDoctor(doctorData) {
  return {
    name: doctorData?.name || "",
    identifier: {
      type: CONSENT_REQUESTER_IDENTIFIER_TYPE,
      value: doctorData?.registration_no || "",
      system: CONSENT_REQUESTER_IDENTIFIER_SYSTEM,
    },
  };
}
